import {BehaviorSubject, Observable} from 'rxjs';
import {Injectable} from '@angular/core';

export declare type SoType = '' | 'assets' | 'date';

@Injectable({
  providedIn: 'root'
})
export class SoService {

  private soActive: SoType = '';
  private soActive$ = new BehaviorSubject<SoType>('');

  newSoActive(newState: SoType): void {
    if (newState === this.soActive) {
      newState = '';
    }
    this.soActive = newState;
    this.soActive$.next(newState);
  }

  onNewSoActive(): Observable<SoType> {
    return this.soActive$.asObservable();
  }

  getSoActive(): SoType {
    return this.soActive$.getValue();
  }

}
